import throttle from 'lodash.throttle';
import { Card } from 'lucid-components-react';
import React, { ReactNode, useEffect, useState } from 'react';

const CardContainer = ({ children }: { children: ReactNode }) => {
  const [showCard, setShowCard] = useState(true);

  const handleResize = throttle(
    () => {
      if (typeof window !== 'undefined') {
        const windowWidth = window.innerWidth;
        if (windowWidth < 767) {
          setShowCard(false);
        } else {
          setShowCard(true);
        }
      }
    },
    100,
    { trailing: true }
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [showCard]);

  return !showCard ? <div>{children}</div> : <Card isRaised>{children}</Card>;
};

export default CardContainer;
